import { useOktaAuth } from "@okta/okta-react"
import { Navigate } from "react-router-dom"
import { LogIn } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

export function LoginPage() {
  const { oktaAuth, authState } = useOktaAuth()

  const handleLogin = async () => {
    const originalUri = oktaAuth.getOriginalUri() || "/alfred/clients"
    await oktaAuth.signInWithRedirect({ originalUri })
  }

  if (authState?.isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="bg-card border-border max-w-md w-full">
        <CardContent className="flex flex-col items-center justify-center py-16 px-6">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted/50 mb-6">
            <img src={import.meta.env.VITE_APP_ICON} alt="logo" />
          </div>
          <h1 className="text-2xl font-semibold text-foreground mb-2">Device Config</h1>
          <p className="text-sm text-muted-foreground mb-8 text-center">
            Sign in to access the device configuration dashboard.
          </p>
          <Button
            onClick={handleLogin}
            className="bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Sign in with Okta
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
